import React from 'react'
import "./room.scss"
import RoomCard from "./RoomCard"
import { useTranslation } from 'react-i18next'
import APPLICATIONS from "../../data/Applications"
import { useNavigate } from "react-router-dom"
import { useScrollReveal } from "../../../utils/useScrollReveal"

const Room = () => {
  const applicationId = APPLICATIONS[0].id
  const { t } = useTranslation('home')
  const navigate = useNavigate()
  const { ref, visible } = useScrollReveal<HTMLElement>()

  const handleShowRooms = () => {
    navigate('/rooms')
  }

  return (
    <section className={`room padding reveal${visible ? ' visible' : ''}`} id='rooms' ref={ref}>
      <div className='container'>
        <div className='section-header'>
          <span className='section-label'>{t('Our rooms', { ns: 'rooms' })}</span>
          <h2>{t('Live your finest moments')}</h2>
          <p className='intro'>{t('Each room bears the name of a Sologne flower. Each stay is a parenthesis of grace.')}</p>
          <span className='gold-rule' />
        </div>
        <div className="room-container">
          <RoomCard applicationId={applicationId} mode="home" />
        </div>
        <div className="button-container">
          <button onClick={handleShowRooms} className="show-rooms-button">
            {t('Show More')}
          </button>
        </div>
      </div>
    </section>
  )
}

export default Room
